import type { Router } from '@angular/router';
import { from, map, type Observable, switchMap } from 'rxjs';
import { openOKDialog } from '@pct-ng/feature-message-material';
import { messageDialogOptionsGenerator } from '../../message-dialog-options-generator';
import type { NotFoundEndpointError } from './not-found-endpoint.error';
import { HandledErrorResponse } from '../../handled-error-response';

export function handleNotFoundEndpointError(
  i18nScope: string,
  router: Router,
  message: string,
  status: number,
  response: any,
  headers: {
    [p: string]: any;
  },
  error: NotFoundEndpointError,
): Observable<NotFoundEndpointError> {
  return openOKDialog(messageDialogOptionsGenerator(`${i18nScope}.NOT_FOUND_ENDPOINT`)).pipe(
    switchMap(() =>
      from(router.navigate(['/'])).pipe(
        map(() => new HandledErrorResponse(message, status, response, headers, error)),
      ),
    ),
  );
}
